export default __webpack_public_path__ + "static/media/fondo2.93c48202.png";